import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { useNavigation } from '@/hooks/navigation';

import { ScDescriptionSection } from './styled';

export const DescriptionSection = () => {
  const { t } = useTranslation('jackpot');
  const { generateLink } = useNavigation();

  return (
    <ScDescriptionSection>
      <div className="text">
        {t('description1')}
        <br />
        <br />
        {t('description2')}
      </div>
      <div className="btn-container">
        <Button
          primary
          small
          wide
          to={generateLink('/games/trending#gamesSection')}
        >
          {t('button.hitJackpot')}
        </Button>
      </div>
    </ScDescriptionSection>
  );
};
